import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';

import appRenamer from './appRenamer.js';
import networkRenamer from './networkRenamer.js';
import countryRenamer from './countryNamer.js';
import Loader from './loader.js';

import DatePicker from './datePicker.js';

import './css/dashboard.css';

function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min)) + min; //The maximum is exclusive and the minimum is inclusive
}

function getRandomArbitrary(min, max) {
  return Math.random() * (max - min) + min;
}

class Dashboard extends Component {

  constructor(props,match){
    super(props);

    this.date = this.props.date;
    
    this.state = {
      loading: true,
      customDate: this.date !== 'last+week',
      showMainGraph: true,
      countries: [
        {
          country: 'IN',
          revenues: getRandomInt(1000,5000)
        },
        {
          country: 'RU',
          revenues: getRandomInt(1000,5000)
        },
        {
          country: 'US',
          revenues: getRandomInt(1000,5000)
        },
        {
          country: 'CA',
          revenues: getRandomInt(1000,5000)
        },
        {
          country: 'BR',
          revenues: getRandomInt(1000,5000)
        },
        {
          country: 'IL',
          revenues: getRandomInt(1000,5000)
        },
        {
          country: 'JP',
          revenues: getRandomInt(1000,5000)
        }
      ],
      mainGraph: [
        {
          date: new Date('2017-10-01'),
          revenues: getRandomInt(1000,5000)
        },
        {
          date: new Date('2017-10-02'),
          revenues: getRandomInt(1000,5000)
        },
        {
          date: new Date('2017-10-03'),
          revenues: getRandomInt(1000,5000)
        },
        {
          date: new Date('2017-10-04'),
          revenues: getRandomInt(1000,5000)
        },
        {
          date: new Date('2017-10-05'),
          revenues: getRandomInt(1000,5000)
        },
        {
          date: new Date('2017-10-06'),
          revenues: getRandomInt(1000,5000)
        },
        {
          date: new Date('2017-10-07'),
          revenues: getRandomInt(1000,5000)
        }
      ],
      apps: [
        {
          name: 'Yoob Games',
          clientId: 'yoobGames3',
          revenues: getRandomInt(1000,5000),
          impressions: getRandomInt(1000,5000),
          cpm: getRandomArbitrary(2,20)
        },
        {
          name: 'TapVPN',
          clientId: 'tapVpn1',
          revenues: getRandomInt(1000,5000),
          impressions: getRandomInt(1000,5000),
          cpm: getRandomArbitrary(2,20)
        },
        {
          name: 'Yoob Games',
          clientId: 'yoobGames3',
          revenues: getRandomInt(1000,5000),
          impressions: getRandomInt(1000,5000),
          cpm: getRandomArbitrary(2,20)
        },
      ],
      days: [
        {
          date: '01/10/17',
          revenues: getRandomInt(1000,5000),
          impressions: getRandomInt(1000,5000),
          cpm: getRandomArbitrary(2,20)
        },
        {
          date: '02/10/17',
          revenues: getRandomInt(1000,5000),
          impressions: getRandomInt(1000,5000),
          cpm: getRandomArbitrary(2,20)
        },
        {
          date: '03/10/17',
          revenues: getRandomInt(1000,5000),
          impressions: getRandomInt(1000,5000),
          cpm: getRandomArbitrary(2,20)
        },
        {
          date: '04/10/17',
          revenues: getRandomInt(1000,5000),
          impressions: getRandomInt(1000,5000),
          cpm: getRandomArbitrary(2,20)
        },
        {
          date: '05/10/17',
          revenues: getRandomInt(1000,5000),
          impressions: getRandomInt(1000,5000),
          cpm: getRandomArbitrary(2,20)
        },
        {
          date: '06/10/17',
          revenues: getRandomInt(1000,5000),
          impressions: getRandomInt(1000,5000),
          cpm: getRandomArbitrary(2,20)
        },
        {
          date: '07/10/17',
          revenues: getRandomInt(1000,5000),
          impressions: getRandomInt(1000,5000),
          cpm: getRandomArbitrary(2,20)
        },
      ],
      networks: [
        {
          name: 'Double Exchange',
          id: 'dfp',
          revenues: getRandomInt(1000,5000),
          impressions: getRandomInt(1000,5000),
          cpm: getRandomArbitrary(2,20)
        },
        {
          name: 'Facebook Audience',
          id: 'facebook',
          revenues: getRandomInt(1000,5000),
          impressions: getRandomInt(1000,5000),
          cpm: getRandomArbitrary(2,20)
        },
        {
          name: 'Chartboost',
          id: 'chartboost',
          revenues: getRandomInt(1000,5000),
          impressions: getRandomInt(1000,5000),
          cpm: getRandomArbitrary(2,20)
        },
      ]
    };
    
    this.type = this.props.view;

    // find proper app
    // if (this.type === 'app' || this.type === 'network'){
    //   this.app = this.state.apps.find(app => {
    //     return app.clientId === this.props.clientId;        
    //   });
    // }

    // find proper network 
    if (this.type === 'network'){
      this.networks = this.state.networks.find(network => {
        return network.id === this.props.networkId;        
      });      
    }
    
    this.currenyFormatter =
      new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      });

    this.numberFormatter = new Intl.NumberFormat();
  }

  
  componentWillMount(){

    const formatJSON = json => {
      json.mainGraph = json.mainGraph.map( row => {
        row.date = new Date(row.date);
        return row;
      });

      return json;
    };
    
    // send to server

    let postData = {
      type: this.type,
      date: this.date
    };

    if (this.type == 'app'){
      postData.clientId = this.props.clientId;
    }

    if (this.type == 'network'){
      postData.clientId = this.props.clientId;
      postData.network = this.props.networkId;
    }

    
    var request = new Request(
      "/ajax/getDashboard.php",{
        method: 'POST',
        credentials: "same-origin",
        body: JSON.stringify(postData), 
        headers: new Headers()
      });

    
    fetch(request)
      .then(rsp => rsp.json())
      .then(formatJSON)
    // network rename
      .then(json => {
        if (this.type == 'app' && this.props.isAdmin){
          json.networks = json.networks.map(network => {
            network.name = networkRenamer(network.network);
            network.id = network.network;

            delete network.network;

            return network;
          });
          
        }
        return json;
      })
      .then(json => {
        json.loading = false;
        this.setState(json);
      }).then( _ => {
        this.createGraps();
      });
  }


  setCustomDate(){
    if (!this.state.customDate){
      this.setState({
        customDate: true
      });
        
    } else {

      let date = `${this.startDate.date}+${this.endDate.date}`;
      let redirectUrl;

      switch(this.type){
      case 'main':
        redirectUrl = `/dashboard/${date}`;
        break;
      case 'app':
        redirectUrl = `/dashboard/${date}/${this.props.clientId}`;
        break;
      case 'network':      
        redirectUrl = `/dashboard/${date}/${this.props.clientId}/${this.props.networkId}`;
        break;      

      }
      
      this.setState({
        redirect: redirectUrl
      });
    }
  }
  
  createGraps(){
    if (!this.state.loading && this.state.mainGraph.length > 0){
      let google = window.google;

      google.charts.load('current', {
        packages: ['line', 'geochart']
      });

      google.charts.setOnLoadCallback( _ => {

        /*
         * Main Graph
         */
        
        let data = new google.visualization.DataTable();

        data.addColumn('date', '');
        data.addColumn('number', 'revenues');

        data.addRows(this.state.mainGraph.map( item => [
          item.date, item.revenues
        ]));

        let chart = new google.charts.Line(
          document.getElementById('main-graph'));

        let options = {
          legend: {
            position: 'none'
          },
				  pointSize: 10,
				  colors: ['#0fbcdb'],
          height: 400,
				  // chartArea: {
				  // 	top: 20,
				  // 	left: 120,
				  // 	width: '100%',
				  // 	height: '85%'
				  // },
          // theme: 'maximized',
          fontName: 'Roboto',
          tooltip: {
            textStyle: {
              fontName: 'Roboto'
            }
          },
          // colors: ['#9AA215'],
          hAxis: {
            title: 'Date',
            gridlines: {
              color: 'transparent'
            }
          },
          vAxis: {
            title: 'Revenue',
            format: 'currency',
            gridlines: {
              color: '#f1f1f1'
            }
          }
        };

        chart.draw(
          data,
          google.charts.Line.convertOptions(options)         
        );


        /*
         * GeoChart
         */
        let geoData = new google.visualization.DataTable();

        geoData.addColumn('string', 'Country');
        geoData.addColumn('number', 'Revenues');

        geoData.addRows(this.state.countries.map( item => [
          item.country, item.revenues
        ]));

        let geoChart = new google.visualization.GeoChart(
          document.getElementById('country-graph'));

        let geoOptions = {
          legend: 'none',
				  pointSize: 10,
				  colors: ['#0fbcdb'],
				  // chartArea: {
				  // 	top: 20,
				  // 	left: 80,
				  // 	width: '100%',
				  // 	height: '85%'
				  // },
          fontName: 'Roboto',
          tooltip: {
            textStyle: {
              fontName: 'Roboto'
            }
          },
          // colors: ['#9AA215'],
          hAxis: {
            title: 'Date'
          },
          vAxis: {
            title: 'Revenue',
            format: 'currency'
          }
        };

        geoChart.draw(geoData, geoOptions);

        
      });
    }
  }

  appsTable(){
    return (
      <table className="table">
        <thead>
          <tr>
            <th>App Name</th>
            <th>Revenues</th>
            <th>Impressions</th>
            <th>CPM</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {this.state.apps.map((app,idx) => {
            return (
              <tr key={idx}>
                <td>                
                  <img height="50" className="app-icon" src={`/icon.php?package=${app.package}`} />
                  <span className="app-name">{app.name}</span>
                </td>
                <td>{this.currenyFormatter.format(app.revenues)}</td>
                <td>{this.numberFormatter.format(app.impressions)}</td>
                <td>{this.currenyFormatter.format(app.cpm)}</td>                  
                <td>
                  <Link to={`/dashboard/${this.date}/${app.clientId}`}
                        className="btn btn-primary">
                    <i className="fa fa-android"/>
                    View App
                  </Link>
                </td>
              </tr>);
          })}
      </tbody>
   </table>);
  }

  showMainGraph(){
    this.setState({
      showMainGraph: true
    });
  }

  showCountriesGraph(){
    this.setState({
      showMainGraph: false
    });
  }

  networksTable(){
    return (
      <table className="table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Revenues</th>
            <th>Impressions</th>
            <th>CPM</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {this.state.networks.map((network,idx) => {
            return (
              <tr key={idx}>
                <td>                
                  {network.name}
                </td>
                <td>{this.currenyFormatter.format(network.revenues)}</td>
                <td>{this.numberFormatter.format(network.impressions)}</td>
                <td>{this.currenyFormatter.format(network.cpm)}</td>                  
                <td>
                  <Link to={`/dashboard/${this.date}/${this.props.clientId}/${network.id}` }
                        className="btn btn-primary">
                    View Network
                  </Link>
                </td>
              </tr>);
          })}
      </tbody>
        </table>);
  }

  countriesTable(){
    return (
      <table className="table">
        <thead>
          <tr>
            <th>Country</th>
            <th>Revenues</th>
            <th>Impressions</th>
            <th>CPM</th>
          </tr>
        </thead>
        <tbody>
          {this.state.countries.map((country,idx) => {
            return (
              <tr key={idx}>
                <td>                
                  {countryRenamer(country.country)}
                </td>
                <td>
                  {this.currenyFormatter.format(
                  country.revenues)}
                </td>
                <td>
                  {this.numberFormatter.format(
                  country.impressions)}
                </td>
                <td>{this.currenyFormatter.format(
                  country.cpm)}</td>                  
              </tr>);
          })}
      </tbody>
        </table>);
  }

    daysTable(){
    return (
      <table className="table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Revenues</th>
            <th>Impressions</th>
            <th>CPM</th>
          </tr>
        </thead>
        <tbody>
          {this.state.days.map((day,idx) => {
            return (
              <tr key={idx}>
                <td>                
                  {day.date}
                </td>
                <td>{this.currenyFormatter.format(day.revenues)}</td>
                <td>{this.numberFormatter.format(day.impressions)}</td>
                <td>{this.currenyFormatter.format(day.cpm)}</td>                  
              </tr>);
          })}
      </tbody>
        </table>);
  }


  
  render() {

    if(this.state.redirect){
      return <Redirect to={this.state.redirect}/>;
    }
    
    let tableTitle;
    
    if (this.state.loading){
      return (
        <Loader/>
        //<div id="loading">Dashboard Is Loading...</div>        
      );
    }

    /*
     * apps pending approval
     */

    let pendingTable;

    if (this.props.pendingApps.length > 0){
      pendingTable = (        
       <div id="pendinga-apps">
          <h3>Apps Pending Approval</h3>
          <p>
           Meanwhile please integrate the Appbid SDK, and send a test request - for your app to enter a manual review process - reviews take 1-2 days on average
          </p>
          <table className="table">
            <thead>
              <tr>
                <th>App Name</th>
                <th>Package</th>
                <th>API Key</th>
                <th>Status</th>          
              </tr>
            </thead>
            <tbody>
              {this.props.pendingApps.map((app,idx) => {
                return (
                  <tr key={idx}>
                    <td>
                      <img height="50" className="app-icon" src={`/icon.php?package=${app.package}`} />
                      <span className="app-name">{app.name}</span>
                    </td>
                    <td>
                      {app.package}
                    </td>
                    <td>
                      {app.clientId}
                    </td>
                    <td>
                      <span className="text-danger">
                        Pending Approval
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      );
    } else {
      pendingTable = (
        <div>
          <h2>Thanks for signing up for AppBid.</h2>

          <p>
            We are an Intelligent Ad Routing solution for mobile app publishers. <br/>
            We help publishers like you, unleash your app's ad revenue potential by having over 15 ad demand sources compete for your app's ad impression.
          </p>


          <p>
            Here's how to get started with Appbid: <br/>
The first step is to integrate the Appbid SDK into your app. Simply click on the button below and follow the instructions.
          </p>
          <Link className="btn btn-primary" to="/apps/create">Integrate SDK</Link>
        </div>
       );
    }
    
    let table;
    let isEmptyDashboard = false;
    switch(this.type){
    case 'main':

      //NOTE(stas): only needed for main dashboard
      if (this.state.apps.length === 0){
        isEmptyDashboard = true;
        break;
      }
      
      table = this.appsTable();
      tableTitle = 'By App';
      break;
    case 'app':
      if (this.props.isAdmin){
        table = this.networksTable();
        tableTitle = 'By Network';
      } else {
        table = this.daysTable();
        tableTitle = 'By Date';        
      }
      break;
    case 'network':      
      table = this.daysTable();
      tableTitle = 'By Date';
      break;      
    }

    // are you looking by date?
    if (!this.state.showMainGraph){
      table = this.countriesTable();
      tableTitle = 'By Country';      
    }

    let desc = <small>All Apps</small>;

    if (this.type == 'app'){
      let app = appRenamer(this.props.apps, this.props.clientId);
      desc = <small>{app.name}</small>;
    }

    if (this.type == 'network'){
      let app = appRenamer(this.props.apps, this.props.clientId);
      let network = networkRenamer(this.props.networkId);
      
      desc = <small>{app.name} <small>{network}</small></small>;
    }
    
    let normalDashboard = (
      <div id="dashboard">
        <h1>
          Dashboard {desc}
        </h1>
        <hr/>
        <h4>Today's Estimated Revenues:</h4>
        <div id="today-esimated" className="row">
          <div className="estimate-box col-md-4">
            <div className="title">Revenues:</div>
            <div className="value">
              {this.currenyFormatter.format(this.state.todayData.revenues)}
            </div>
          </div>
          <div className="estimate-box col-md-4">
            <div className="title">Impressions:</div>
            <div className="value">
              {this.numberFormatter.format(this.state.todayData.impressions)}
            </div>
          </div>
          <div className="estimate-box col-md-4 last">
            <div className="title">CPM:</div>
            <div className="value">
              {this.currenyFormatter.format(this.state.todayData.cpm)}
            </div>
          </div>
        </div>
        <h4>
          { !this.state.customDate &&
          "Last Week Revenues:" }

          { this.state.customDate && (
            <div className="date-group">
              <label>From:</label>
              <DatePicker date={this.state.startDate} ref={el => this.startDate = el}/>
              <label>To:</label>
              <DatePicker date={this.state.endDate} ref={el => this.endDate = el}/>
            </div>) }
          
          <button id="date-btn" className="btn btn-success"
                  onClick={this.setCustomDate.bind(this)}>
                {!this.state.customDate ? "Change Date" :
                  "Set Date"}                
          </button>
                      
          <div id="graph-buttons"
               className="graph-type btn-group pull-right" role="group">
            <button
              type="button"
              className={"btn btn-default" + (this.state.showMainGraph ? " active" : "")}
              onClick={this.showMainGraph.bind(this)}>By Date</button>
            <button
              type="button"
              className={"btn btn-default" + (!this.state.showMainGraph ? " active" : "")}
              onClick={this.showCountriesGraph.bind(this)}>By Country</button>
          </div>
          <div className="clearfix"/>
        </h4>
        <div id="main-graph" style={{display: this.state.showMainGraph ? "block" : "none" }}></div>
        <div id="country-graph" style={{display: !this.state.showMainGraph ? "block" : "none" }}></div>

        <h4>{tableTitle}:</h4>
        {table}

        {pendingTable}
      </div>
    );

    let emptyDashboard = (
      <div id="dashboard">
        {pendingTable}
      </div>
    );

    return !isEmptyDashboard ? normalDashboard : emptyDashboard;
  }
}

export default Dashboard;













// WEBPACK FOOTER //
// ./src/dashboard.js